module.exports = __webpack_public_path__ + "static/media/caseActivity.577bf7d4.jpg";